module.exports = __webpack_public_path__ + "static/img/logos_220px_effmaster.e366c72.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/open/panels/cooperation/img/other/logos_220px_effmaster.png
// module id = OBj5
// module chunks = 0